import React, { useRef, useState } from "react";
import { useParams } from "react-router-dom";
import CaseLine from "./CaseLine";
import CaseWin from "./CaseWin";
import "./style/CaseDetail.css";

import Toncoin from "../assets/image/toncoin.svg";
import SCoin from "../assets/image/S-coint.svg";

import { useNavigate } from 'react-router-dom';

export default function CaseDetail({ cases }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const caseItem = cases.find((c) => c.id === parseInt(id));

  const min_bounty = caseItem.value / 2;
  const max_bounty = caseItem.value * 3;

  // Состояние для выбранного множителя (кол-во одновременно открываемых кейсов)
  const [multiplier, setMultiplier] = useState(1);
  // Список ref'ов для каждой ленты
  const [lineRefs, setLineRefs] = useState([React.createRef()]);

  const [targetCount, setTargetCount] = useState(caseItem.value * 1.5);

  const [wins, setWins] = useState([]);
  const [completed, setCompleted] = useState(0);
  const [showResult, setShowResult] = useState(false);

  // Обновляем refs при смене multiplier
  const handleMultiplierChange = (value) => {
    setMultiplier(value);
    setLineRefs(Array.from({ length: value }, () => React.createRef()));
  };

  const handleOpen = () => {
    lineRefs.forEach((ref) => {
      ref.current?.roll(1, targetCount);
    });
  };

  const handleQuickOpen = () => {
    lineRefs.forEach((ref) => {
      ref.current?.roll(3, targetCount);
    });
  };

  const handleWin = (value) => {
    setWins((prev) => [...prev, { value}]);

    setCompleted((c) => {
      const n = c + 1;
      if (n === multiplier) {
        setShowResult(true);
      }
      return n;
    });
  };


  const resetCase = () => {
    navigate(0);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
      }}
    >
      <>
        <div style={{display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", justifyContent: "center", marginBottom: "-8px"}}>
          <img src={caseItem.image} alt={caseItem.name} className="case-header-image"></img>
          <span className="case-header">{caseItem.name}</span>
        </div>

        <div style={{ width: "110%" }}>
          <div
            style={{
              display: "flex",
              gap: 12,
              flexWrap: "wrap",
              justifyContent: "center",
              width: "100%"
            }}
          >
            {lineRefs.map((ref, idx) => (
              <CaseLine
                key={idx}
                ref={ref}
                min_bounty={min_bounty}
                max_bounty={max_bounty}
                base_bounty={caseItem.value}
                onWin={handleWin}
                baseCaseColor={caseItem.color}
                needSound={idx === 0}
              />
            ))}
          </div>
        </div>
        
        <div style={{ display: "flex", flexDirection: "column", gap: 12, alignItems: "center" }}>
          <div style={{ display: "flex", justifyContent: "center", overflow: "hidden", borderRadius: 50, gap: 2, width: "333px"}}>
            {[1, 2, 3, 4, 5].map((num) => (
              <button
                key={num}
                className={`multiply-button ${multiplier === num ? "active" : ""}`}
                onClick={() => handleMultiplierChange(num)}
              >
                {num}x
              </button>
            ))}
              <button
                key="Demo"
                className={`multiply-button ${""}`}
              >
                Демо
              </button>
          </div>

          <div style={{display: "flex", justifyContent: "center", gap: 10, maxWidth: "410px" }}>
            <button className="action-button left" onClick={handleOpen}>
              <span className="label" style={{ marginLeft: "-20px" }}>Открыть {multiplier > 1 ? multiplier : ""} за</span>
              <span className="price-row" style={{ marginLeft: "-20px" }}>
                <img src={Toncoin} alt="" />
                {(caseItem.value * 0.0065 * multiplier).toFixed(2)}
              </span>
            </button>

            <button className="action-button right" onClick={handleQuickOpen}>
              <span className="label">Открыть {multiplier > 1 ? multiplier : ""} за</span>
              <span className="price-row">
                <img src={SCoin} alt="" />
                {(caseItem.value * 1.65 * multiplier).toFixed(2)}
              </span>
            </button>
          </div>
        </div>
      </>

      {showResult && wins.length > 0 && (
        <CaseWin
          cases={wins.map(w => ({
            value: w.value,
            case_color: caseItem.color,
            jackpot: false
          }))}
          onComplete={() => {
              resetCase();
          }}
        />
      )}
    </div>
  );
}
